import styled from 'styled-components';
import { Row as AntdRow, Col as AntdCol } from 'antd';
interface ContainerProps {
  size?: string;
}
export const Row = styled(AntdRow)<ContainerProps>`
  // margin-top: 0.5rem;
  // margin: 0 16px;
  width: 91.53%;
  margin: 0 auto;
`;

export const GreetingBox = styled(AntdCol)<{ isReminder: boolean }>`
  margin-left: 0.5rem;
  ${(props) =>
    props.isReminder &&
    `
      display: flex;
      gap: 8px;
      flex-direction: column;
    `}
`;
